export default __webpack_public_path__ + "static/media/internship-world-map.3757788d.png";